import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import IndexSection__forms1 from '../components/__forms/IndexSection__forms1';
import IndexSectionCookies7 from '../components/cookies/IndexSectionCookies7';
import IndexSection__forms2 from '../components/__forms/IndexSection__forms2';
import IndexSectionPricing9 from '../components/pricing/IndexSectionPricing9';
import IndexSectionFaqs6 from '../components/faqs/IndexSectionFaqs6';
import IndexSectionCallToAction8 from '../components/call-to-action/IndexSectionCallToAction8';
import IndexSectionContacts5 from '../components/contacts/IndexSectionContacts5';
import IndexSection__forms3 from '../components/__forms/IndexSection__forms3';

const meta = {
  title: 'Ordio\u0020\u2014\u0020Homepage',
  meta: [],
  link: [],
  style: [],
  script: [
    {
      src: 'js/global-2274.js',
    },
  ],
};

export default function Index() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <IndexSection__forms1 />
      <IndexSectionCookies7 />
      <IndexSection__forms2 />
      <IndexSectionPricing9 />
      <IndexSectionFaqs6 />
      <IndexSectionCallToAction8 />
      <IndexSectionContacts5 />
      <IndexSection__forms3 />
    </React.Fragment>
  );
}

